import getHeaders from './header';
import userStore from "../store/userStore";
// import { addNotification } from '../action/notificationAction';
import axios from 'axios';
import { Config } from '../config';

const urlStarter = Config[Config.env].functionappurl;

export const saveTemplate = async (companyId, templateName, templateString) => {
    const url = urlStarter + 'api/dohertyPortal?saveTemplate=' + companyId + '&userId=' + userStore.user.id;
    let payload = {
        template: { templateName: templateName, templateString }
    };
    const headers = await getHeaders();

    const response = await axios.post(url, payload, { headers: headers });
    return response.data;
};


// WEBPACK FOOTER //
// ./src/services/templateManager.js